import styled from 'styled-components';
import { BasketFeesDetailsStyled } from '../BasketFeesDetailsStyled';
import { rem } from 'polished';

export const BasketFeesDetailsAP = styled(BasketFeesDetailsStyled)``;
